/*------------------------------------------------------------------
Search Controller
------------------------------------------------------------------*/

class SearchController extends Classy {
  constructor(form) {
    super();
    this.html = document.querySelector('html');
    this.form = form;
    this.active = false;
    this.button = null;

    // If the user presses the escape key, close the search
    window.addEventListener('keyup', e => {
      if (e.key === 'Escape') this.close();
    });
  }
  toggle() {
    this.active ? this.close() : this.open();
    // The callback
    this.callback('toggle', this.active);
  }
  close() {
    this.active = false;
    this.html.classList.remove('search-form-active');

    // If there is a button, focus it
    if (this.button) this.button.focus();

    // The callback
    this.callback('close');
  }
  open() {
    this.active = true;
    this.html.classList.add('search-form-active');
    this.form.querySelector('input').focus();

    // The callback
    this.callback('open');
  }
  scrollToTop() {
    this.form.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // The callback
    this.callback('scrollToTop');
  }
  addButton(el) {
    let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'open';
    // Make sure this action exists
    if (!this[action]) return console.error(`The action ${action} does not exist on the SearchController`);
    el.addEventListener('click', e => {
      e.preventDefault();
      this[action]();
      this.button = el;
    });
  }
}
[...document.querySelectorAll('.js-search')].forEach(() => {
  const form = document.querySelector('.js-search-modal');

  // If there is no form, return
  if (!form) return;

  // Create the SearchController
  window.SearchModal = new SearchController(form);

  // Loop all the buttons
  [...document.querySelectorAll('.js-search__button')].forEach(button => {
    SearchModal.addButton(button, 'open');
  });
  SearchModal.on('open', () => {
    ScrollLocker.lock();
  });
  SearchModal.on('close', () => ScrollLocker.unlock());
});
import('scripts/marmalade/indexed-search/index');